<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton 
                :showBtn="false"
                title="Incentive Process"
            />
        </div>

         <section id="basic-tabs-components">
        <div class="row match-height">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                  <li class="nav-item active">
                    <a class="nav-link active" id="home-tab-fill" data-bs-toggle="tab" href="#incentive-process-tab" role="tab" aria-controls="incentive-process-tab" aria-selected="false">Incentive Process</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" id="item-tab-fill" data-bs-toggle="tab" href="#level-update-tab" role="tab" aria-controls="level-update-tab" aria-selected="false">Level Update</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" id="item-tab-fill" data-bs-toggle="tab" href="#group-sales-commission-tab" role="tab" aria-controls="group-sales-commission-tab" aria-selected="false">Group Sales Commission</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" id="item-tab-fill" data-bs-toggle="tab" href="#company-sale-share-tab" role="tab" aria-controls="company-sale-share-tab" aria-selected="false">Company Sale Share</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" id="item-tab-fill" data-bs-toggle="tab" href="#staff-register-create-tab" role="tab" aria-controls="staff-register-create-tab" aria-selected="false">Staff Register Create</a>
                  </li>
                </ul>
                <hr>

                <div class="tab-content">
                  <div class="tab-pane show active" id="incentive-process-tab" role="tabpanel" aria-labelledby="incentive-process-tab-fill">
                    <div class="row">
                      <div class="col-12 col-sm-6 col-md-3 col-lg-3  mb-1">
                        <div class="mb-1">
                          <label for="colFormLabel" class="col-form-label">Month</label>
                          <vField
                              v-model="month"
                              name="month"
                              id="month"
                              type="month"
                              class="form-control"
                          />
                        </div>
                      </div>
                      <div class="col-12 col-sm-6 col-md-1 col-lg-1 mb-1 mt-2">
                        <button
                            style="min-width: 64px;"
                            @click="onClickToGo"
                            class="btn btn-primary btn-block waves-effect waves-float waves-light"
                        > Process
                        </button>
                      </div>
                    </div>
                    <div class="card p-2" style="min-height: 200px">
                      <div class="table-responsive">
                      <table class="table table-bordered">
                        <thead>
                        <tr>
                          <th class="text-center">Type</th>
                          <th class="text-center">Month-Year</th>
                          <th class="text-center">Status</th>
                          <th class="text-center">Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, i) in incentiveProcessLogList" :key="i">
                          <td class="text-center text-capitalize">{{ item.type }}</td>
                          <td class="text-center">{{ item.month_year }}</td>
                          <td class="text-center text-capitalize">{{ item.status }}</td>
                          <td v-if="!['reprocessing', 'processing'].includes(item.status)" class="text-center">
                            <button class="btn btn-primary btn-sm"
                                    title="Reprocess"
                                    @click="incentiveReProcessing(item)"
                                    style="cursor: pointer"
                            >
                              <i class="fas fa-eye"></i>
                            </button>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                      <p v-if="incentiveProcessLogList.length < 0" class="text-center mt-5">No data</p>
                    </div>
                    </div>
                    <div class="px-2 position-absolute bottom-0 mt-4">
                      <Pagination :offset="params.offset" @onPageChange="onPageChange" ref="pagination"/>
                    </div>

                  </div>
                  <div class="tab-pane" id="level-update-tab" role="tabpanel" aria-labelledby="level-update-tab-fill">
                    <div class="row">
                      <div class="col-12 col-sm-6 col-md-4 col-lg-3  mb-1">
                        <div class="mb-1">
                          <label for="colFormLabel" class="col-form-label">Month</label>
                          <vField
                              v-model="levelUpdateDate"
                              name="month"
                              id="month"
                              type="date"
                              class="form-control"
                          />
                        </div>
                      </div>
                      <div class="col-12 col-md-4 mb-1 mt-2">
                        <button
                            style="min-width: 124px;"
                            @click="onClickLevelUpdate"
                            class="btn btn-primary btn-block"
                        > Level Update Process
                        </button>
                      </div>
                    </div>

                    <div class="card p-2" style="min-height: 200px">
                      <div class="table-responsive">
                        <table class="table table-bordered">
                          <thead>
                          <tr>
                            <th class="text-center">Type</th>
                            <th class="text-center">Month-Year</th>
                            <th class="text-center">Status</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="(item, i) in levelUpdateLogList" :key="i">
                            <td class="text-center text-capitalize">{{ item.type }}</td>
                            <td class="text-center">{{ item.date }}</td>
                            <td class="text-center text-capitalize">{{ item.status }}</td>
                          </tr>
                          </tbody>
                        </table>
                        <p v-if="levelUpdateLogList.length < 0" class="text-center mt-5">No data</p>
                      </div>
                    </div>
                    <div class="px-2 position-absolute bottom-0 mt-4">
                      <Pagination :offset="params.offset" @onPageChange="onPageLevelChange" ref="pagination"/>
                    </div>
                  </div>
                  <div class="tab-pane" id="group-sales-commission-tab" role="tabpanel" aria-labelledby="group-sales-commission-tab-fill">
                    <div class="row">
                      <div class="col-12 col-sm-6 col-md-3 col-lg-3  mb-1">
                        <div class="mb-1">
                          <label for="colFormLabel" class="col-form-label">Month</label>
                          <vField
                              v-model="month"
                              name="month"
                              id="month"
                              type="month"
                              class="form-control"
                          />
                        </div>
                      </div>
                      <div class="col-12 col-sm-6 col-md-1 col-lg-1 mb-1 mt-2">
                        <button
                            style="min-width: 64px;"
                            @click="onClickGroupSaleCommission"
                            class="btn btn-primary btn-block waves-effect waves-float waves-light"
                        > Process
                        </button>
                      </div>
                    </div>
                    <div class="card p-2" style="min-height: 200px">
                      <div class="table-responsive">
                        <table class="table table-bordered">
                          <thead>
                          <tr>
                            <th class="text-center">Type</th>
                            <th class="text-center">Month-Year</th>
                            <th class="text-center">Status</th>
                            <th class="text-center">Action</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="(item, i) in groupSalesCommissionLogList" :key="i">
                            <td class="text-center text-capitalize">{{ item.type }}</td>
                            <td class="text-center">{{ item.month_year }}</td>
                            <td class="text-center text-capitalize">{{ item.status }}</td>
                            <td v-if="!['reprocessing', 'processing'].includes(item.status)" class="text-center">
                              <button class="btn btn-primary btn-sm"
                                      title="Reprocess"
                                      @click="incentiveReProcessing(item)"
                                      style="cursor: pointer"
                              >
                                <i class="fas fa-eye"></i>
                              </button>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                        <p v-if="groupSalesCommissionLogList.length < 0" class="text-center mt-5">No data</p>
                      </div>
                    </div>
                    <div class="px-2 position-absolute bottom-0 mt-4">
                      <Pagination :offset="params.offset" @onPageChange="onPageGroupSaleChange" ref="pagination"/>
                    </div>

                  </div>
                  <div class="tab-pane" id="company-sale-share-tab" role="tabpanel" aria-labelledby="company-sale-share-tab-tab-fill">
                    <div class="row">
                      <div class="col-12 col-sm-6 col-md-3 col-lg-3  mb-1">
                        <div class="mb-1">
                          <label for="colFormLabel" class="col-form-label">Month</label>
                          <vField
                              v-model="month"
                              name="month"
                              id="month"
                              type="month"
                              class="form-control"
                          />
                        </div>
                      </div>
                      <div class="col-12 col-sm-6 col-md-1 col-lg-1 mb-1 mt-2">
                        <button
                            style="min-width: 64px;"
                            @click="onClickCompanySaleProcess"
                            class="btn btn-primary btn-block waves-effect waves-float waves-light"
                        > Process
                        </button>
                      </div>
                    </div>
                    <div class="card p-2" style="min-height: 200px">
                      <div class="table-responsive">
                        <table class="table table-bordered">
                          <thead>
                          <tr>
                            <th class="text-center">Type</th>
                            <th class="text-center">Month-Year</th>
                            <th class="text-center">Status</th>
                            <th class="text-center">Action</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="(item, i) in companySaleShareProcessList" :key="i">
                            <td class="text-center text-capitalize">{{ item.type }}</td>
                            <td class="text-center">{{ item.month_year }}</td>
                            <td class="text-center text-capitalize">{{ item.status }}</td>
                            <td v-if="!['reprocessing', 'processing'].includes(item.status)" class="text-center">
                              <button class="btn btn-primary btn-sm"
                                      title="Reprocess"
                                      @click="incentiveReProcessing(item)"
                                      style="cursor: pointer"
                              >
                                <i class="fas fa-eye"></i>
                              </button>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                        <p v-if="companySaleShareProcessList.length < 0" class="text-center mt-5">No data</p>
                      </div>
                    </div>
                    <div class="px-2 position-absolute bottom-0 mt-4">
                      <Pagination :offset="params.offset" @onPageChange="onPageCompanySaleShareChange" ref="pagination"/>
                    </div>

                  </div>
                  <div class="tab-pane" id="staff-register-create-tab" role="tabpanel" aria-labelledby="staff-register-create-tab-fill">
                    <div class="row">
                      <div class="col-12 col-sm-6 col-md-3 col-lg-3  mb-1">
                        <div class="mb-1">
                          <label class="form-label" for="staff"><span class="required">*</span> Referrer Staff Id</label>
                          <input
                              name="Parent / Reference ID"
                              @input="getReferrerIdByStaffId"
                              type="text" v-model="referrerStaffId"
                              class="form-control"
                          />
                          <transition name="fade">
                            <span v-if="referrerStaffName" class="fw-bold d-block qcont">Referrer Staff: {{ referrerStaffName }}</span>
                          </transition>
                        </div>
                      </div>
                      <div class="col-12 col-sm-6 col-md-3 col-lg-2  mb-1">
                        <div class="mb-1">
                          <label class="form-label" for="staff"><span class="required">*</span> Staff ID Start from</label>
                          <input
                              name="Staff ID Start from"
                              @blur="getStartStaffId"
                              type="text" v-model="startStaffId"
                              class="form-control"
                          />
                        </div>
                      </div>
                      <div class="col-12 col-sm-6 col-md-3 col-lg-2  mb-1">
                        <div class="mb-1">
                          <label class="form-label" for="staff"><span class="required">*</span> How Many Level</label>
                          <input
                              name="How Many Level"
                              type="text" v-model="staffHowManyLevel"
                              class="form-control"
                          />
                        </div>
                      </div>
                      <div class="col-12 col-sm-6 col-md-3 col-lg-3  mb-1">
                      <div class="mb-1">
                          <label class="form-label" for="mobileNo"><span class="required">*</span>  Default Rank</label>
                          <v-select
                              placeholder="Select Rank"
                              v-model="incentiveSetupId"
                              :options="incentiveSetupList"
                              label="name"
                              :reduce="name => name.id"
                          />
                        </div>
                      </div>
                      <div class="col-12 col-sm-6 col-md-1 col-lg-1 mb-1 mt-2">
                        <button
                            style="min-width: 64px;"
                            @click="onClickStaffRegisterProcess"
                            class="btn btn-primary btn-block waves-effect waves-float waves-light"
                        > Process
                        </button>
                      </div>
                    </div>
                    <div class="card p-2" style="min-height: 200px">
                      <div class="table-responsive">
                        <table class="table table-bordered">
                          <thead>
                          <tr>
                            <th class="text-center">Type</th>
                            <th class="text-center">Process Date</th>
                            <th class="text-center">Status</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="(item, i) in staffRegisterProcessList" :key="i">
                            <td class="text-center text-capitalize">{{ item.type }}</td>
                            <td class="text-center">{{ item.date }}</td>
                            <td class="text-center text-capitalize">{{ item.status }}</td>
                          </tr>
                          </tbody>
                        </table>
                        <p v-if="staffRegisterProcessList.length < 0" class="text-center mt-5">No data</p>
                      </div>
                    </div>
                    <div class="px-2 position-absolute bottom-0 mt-4">
                      <Pagination :offset="params.offset" @onPageChange="onPageStaffRegisterChange" ref="pagination"/>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

        <Loader v-if="loading"/>

    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import {inject, onMounted, reactive, ref} from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import handleSdm from "@/services/modules/sdm/sdm";
import { computed } from 'vue';
import Pagination from '@/components/atom/Pagination'
import handleCompanyContact from "@/services/modules/companyContact";
import handleHospital from "@/services/modules/hospital";

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false)
const month = ref(null);
const levelUpdateDate = ref(null);
const incentiveProcessLogList = ref([]);
const levelUpdateLogList = ref([]);
const groupSalesCommissionLogList = ref([]);
const companySaleShareProcessList = ref([]);
const staffRegisterProcessList = ref([]);
let companyInfo = reactive({})
let saveNewButtonLoader = ref(false)
const tableRef = ref(null)
const token = computed(() => localStorage.getItem('token'));
const params = ref({
  offset: 20,
});
const referrerStaffId = ref(null);
const referrerStaffName = ref(null);
const startStaffId = ref(null);
const staffHowManyLevel = ref(null);
const incentiveSetupId = ref(null);
const incentiveSetupList = ref([])
const {
  incentiveRegisterProcess,
  contactProfileLevelUpdate,
  fetchIncentiveProcessLogList,
  updateIncentiveProcessType,
  groupSaleCommissionProcess,
  companySaleShareProcess,
  staffRegisterProcess
} = handleSdm()
const { fetchContactProfileBySerialNo } = handleCompanyContact();
const { fetchIncentiveSetupList } = handleHospital()

const onClickToGo = () => {
  getIncentiveProcess();
}

const setPaginationData = (data) => {
  store.commit('setPaginationData', data)
};

const setLevelPaginationData = (data) => {
  store.commit('setPaginationData', data)
};

const onPageChange = async (page) => {
  let routeQuery = Object.assign({}, route.query)
  routeQuery.page = page
  await router.push({path: route.path, query: routeQuery})
  await getIncentiveProcessList();
}

const onPageLevelChange = async (page) => {
  let routeQuery = Object.assign({}, route.query)
  routeQuery.page = page
  await router.push({path: route.path, query: routeQuery})
  await getLevelUpdateList();
}

const onPageGroupSaleChange = async (page) => {
  let routeQuery = Object.assign({}, route.query)
  routeQuery.page = page
  await router.push({path: route.path, query: routeQuery})
  await getGroupSaleCommissionList();
}

const onPageCompanySaleShareChange = async (page) => {
  let routeQuery = Object.assign({}, route.query)
  routeQuery.page = page
  await router.push({path: route.path, query: routeQuery})
  await getCompanySaleShareProcessList();
}

const onPageStaffRegisterChange = async (page) => {
  let routeQuery = Object.assign({}, route.query)
  routeQuery.page = page
  await router.push({path: route.path, query: routeQuery})
  await getStaffRegisterProcessList();
}

const setLevelPagination = (data) => {
  setLevelPaginationData({
    records: data.total,
    perPage: data.per_page,
    currentPage: data.current_page,
  })
}

const setGroupSalePagination = (data) => {
  setLevelPaginationData({
    records: data.total,
    perPage: data.per_page,
    currentPage: data.current_page,
  })
}

const setCompanySaleProcessPagination = (data) => {
  setLevelPaginationData({
    records: data.total,
    perPage: data.per_page,
    currentPage: data.current_page,
  })
}

const setStaffRegisterPagination = (data) => {
  setLevelPaginationData({
    records: data.total,
    perPage: data.per_page,
    currentPage: data.current_page,
  })
}

const setPagination = (data) => {
  setPaginationData({
    records: data.total,
    perPage: data.per_page,
    currentPage: data.current_page,
  })
}
const getIncentiveProcessList = async () => {
  let query =`?company_id=${route.params.companyId}`;
  if (route.query.page) query += '&page=' + route.query.page;
  query += '&offset=' + params.value.offset
  query += '&type=incentive-register'

  loading.value = true
  incentiveProcessLogList.value = []

  await fetchIncentiveProcessLogList(query).then(res => {
    if (!res.status){
      store.commit("resetPagination")
      return
    }

    incentiveProcessLogList.value = res.data.data;
    setPagination(res.data)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const getLevelUpdateList = async () => {
  let query =`?company_id=${route.params.companyId}`;
  if (route.query.page) query += '&page=' + route.query.page;
  query += '&offset=' + params.value.offset
  query += '&type=level-update'

  loading.value = true
  levelUpdateLogList.value = []

  await fetchIncentiveProcessLogList(query).then(res => {
    if (!res.status){
      store.commit("resetPagination")
      return
    }

    levelUpdateLogList.value = res.data.data;
    setLevelPagination(res.data)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const getGroupSaleCommissionList = async () => {
  let query =`?company_id=${route.params.companyId}`;
  if (route.query.page) query += '&page=' + route.query.page;
  query += '&offset=' + params.value.offset
  query += '&type=group-sale-commission'

  loading.value = true
  groupSalesCommissionLogList.value = []

  await fetchIncentiveProcessLogList(query).then(res => {
    if (!res.status){
      store.commit("resetPagination")
      return
    }

    groupSalesCommissionLogList.value = res.data.data;
    setGroupSalePagination(res.data)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const getCompanySaleShareProcessList = async () => {
  let query =`?company_id=${route.params.companyId}`;
  if (route.query.page) query += '&page=' + route.query.page;
  query += '&offset=' + params.value.offset
  query += '&type=company-sale-share'

  loading.value = true
  companySaleShareProcessList.value = []

  await fetchIncentiveProcessLogList(query).then(res => {
    if (!res.status){
      store.commit("resetPagination")
      return
    }

    companySaleShareProcessList.value = res.data.data;
    setCompanySaleProcessPagination(res.data)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const onClickLevelUpdate = async () => {
  let query = `?company_id=${route.params.companyId}`;
  if (levelUpdateDate.value) query += '&date=' + levelUpdateDate.value;

  loading.value = true

  await contactProfileLevelUpdate(query).then(res => {
    if (!res.status){
      showError(res.message)
      return
    }
    showSuccess(res.message)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const getIncentiveProcess = async () => {
    const query = getQuery();
    loading.value = true

    await incentiveRegisterProcess(query).then(res => {
        if (!res.status){
            showError(res.message)
            return
        }
        showSuccess(res.message)
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        loading.value = false
    })
}

const onClickGroupSaleCommission = async () => {
    const query = getQuery();
    loading.value = true

    await groupSaleCommissionProcess(query).then(res => {
        if (!res.status){
            showError(res.message)
            return
        }
        showSuccess(res.message)
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        loading.value = false
    })
}

const onClickCompanySaleProcess = async () => {
  const query = getQuery();
  loading.value = true

  await companySaleShareProcess(query).then(res => {
    if (!res.status){
      showError(res.message)
      return
    }
    showSuccess(res.message)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const onClickStaffRegisterProcess = async () => {
  let query = `?company_id=${route.params.companyId}`;
  if(referrerStaffId.value) query += '&referrer_staff_id='+ referrerStaffId.value;
  if(startStaffId.value) query += '&start_staff_id='+ startStaffId.value;
  if(staffHowManyLevel.value) query += '&level='+ staffHowManyLevel.value;
  if(incentiveSetupId.value) query += '&incentive_setup_id='+ incentiveSetupId.value;
  loading.value = true

  await staffRegisterProcess(query).then(res => {
    if (!res.status){
      showError(res.message)
      return
    }
    showSuccess(res.message)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const incentiveReProcessing = async (item) => {
  const confirmed = confirm("Are you sure you want to reprocess this month?");
  if (!confirmed) return;

  let query = `?company_id=${route.params.companyId}`;
  loading.value = true
  let processData = {}
  processData.status = 'reprocessing';
  processData.month = item.month_year;

  await updateIncentiveProcessType(processData, item.id, query).then(res => {
    if (!res.status){
      showError(res.message)
      return
    }
    getIncentiveProcessList()
    showSuccess(res.message)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const getQuery = () => {
    let query = `?company_id=${route.params.companyId}`;
    if (month.value) query += '&month=' + month.value;
    return query;
}

const getReferrerIdByStaffId = () => {
  let companyQuery = `?company_id=${route.params.companyId}&roles=employee`
  companyQuery += '&serial_no='+ referrerStaffId.value;
  fetchContactProfileBySerialNo(companyQuery).then(res => {
    if (!res.status) {
      referrerStaffName.value = null;
      return showError(res.message)
    }
    referrerStaffName.value = res.data.full_name;
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const getStartStaffId = () => {
  let companyQuery = `?company_id=${route.params.companyId}&roles=employee`
  companyQuery += '&serial_no='+ startStaffId.value;
  fetchContactProfileBySerialNo(companyQuery).then(res => {
    if (res.status) {
      return showError("This Staff Id Already Assigned")
    }
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const getStaffRegisterProcessList = async () => {
  let query =`?company_id=${route.params.companyId}`;
  if (route.query.page) query += '&page=' + route.query.page;
  query += '&offset=' + params.value.offset
  query += '&type=staff-register'

  loading.value = true
  staffRegisterProcessList.value = []

  await fetchIncentiveProcessLogList(query).then(res => {
    if (!res.status){
      store.commit("resetPagination")
      return
    }

    staffRegisterProcessList.value = res.data.data;
    setStaffRegisterPagination(res.data)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const getIncentiveSetupList = async () => {
  let query = `?company_id=${route.params.companyId}`;
  query += '&is_all=true&incentive_type=level'
  loading.value = true
  incentiveSetupList.value = []

  await fetchIncentiveSetupList(query).then(res => {
    if (!res.status){
      return
    }
    incentiveSetupList.value = res.data;
    let defaultRank = res.data.find(item => item.equivalent_designation == 'MPO')
    if (defaultRank){
      incentiveSetupId.value = defaultRank.id;
    }
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

onMounted(() => {
  Promise.all([
    getIncentiveProcessList(),
    getLevelUpdateList(),
    getGroupSaleCommissionList(),
    getCompanySaleShareProcessList(),
    getIncentiveSetupList(),
    getStaffRegisterProcessList()
  ])
})

</script>

<style scoped>
.head td {
  text-align: right;
}
</style>